import {
  GOOGLE_ADS_CAMPAIGN_STATUS,
  GoogleAdsCampaignConnectionStatus,
} from '../../../../../../services/exports/Constants';

export default {
  title: 'Google Ads',
  search: {
    placeholder: 'Szukaj po ID, nazwie lub firmie',
  },
  filters: {
    connection_statuses: {
      placeholder: 'Status połączenia',
      options: {
        [GoogleAdsCampaignConnectionStatus.Connected]: 'Połączono',
        [GoogleAdsCampaignConnectionStatus.NotConnected]: 'Niepołączono',
      },
    },
  },
  columns: {
    name: 'Nazwa',
    company: 'Firma',
    connected: 'Połączono',
    action: 'Akcja',
    details: 'Szczegóły',
    address: 'Adres',
    status: 'Status',
  },
  status: {
    [GOOGLE_ADS_CAMPAIGN_STATUS.UNSPECIFIED]: 'Nie określono',
    [GOOGLE_ADS_CAMPAIGN_STATUS.ENABLED]: 'Aktywny',
    [GOOGLE_ADS_CAMPAIGN_STATUS.PAUSED]: 'Wstrzymano',
    [GOOGLE_ADS_CAMPAIGN_STATUS.UNKNOWN]: 'Nieznany',
    [GOOGLE_ADS_CAMPAIGN_STATUS.REMOVED]: 'Usunięto',
  },
};
